import { plantCardPath, plantPictureFileName } from '../../domain/plants/plantShare';
import { fetchShareImageFile } from './shareImageFile';

/**
 * Load a plant's scenic card as a `File`, in the language on screen (SPEC-019).
 *
 * The counterpart to `appShareCardFile.js` and `plantSheetFile.js`, over the
 * same fetch. `portrait` is the default for the same reason it is there: this is
 * the file one person hands another, and 4:5 is what a story and a message
 * bubble render whole. `landscape` is the same handover aimed at a Facebook post,
 * where 4:5 is letterboxed and 1.91:1 fills the feed (PR-19.8). The `unfurl`
 * shape exists for the document head and is never fetched by the app.
 */

export async function fetchPlantShareCardFile(
    { plantId, commonName, languageCode, shape = 'portrait' },
    options = {},
) {
    return fetchShareImageFile(
        {
            url: plantCardPath(plantId, languageCode, shape),
            fileName: plantPictureFileName(commonName),
            type: 'image/jpeg',
        },
        options,
    );
}
